export default from './Highlight'



// WEBPACK FOOTER //
// ./src/index.js